/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Event as RouterEvent, NavigationStart, Router, RouterStateSnapshot } from '@angular/router';
import { LmsBaseAppComponent } from './../component/base-app/lms-base-app.component';
import { EditModeService } from './edit-mode.service';


/**
 * @export
 * @class CanDeactivateViaEditGuardService
 * @implements {CanDeactivate<LmsBaseAppComponent>}
 */
@Injectable()
export class CanDeactivateViaEditGuardService  {
  nextUrl;
  constructor(private router: Router, private editModeService: EditModeService) {
    router.events.subscribe((val) => {
      this.navigationInterceptor(val);
    });
  }
  canDeactivate(component: LmsBaseAppComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    if (this.editModeService.isEditMode) {
      component.showRoutePopup(this.nextUrl);
      return false;
    } else {
      // this.router.navigateByUrl(this.nextUrl, { skipLocationChange: environment.hideUrl });
      // return false;
    }
    return true;

  };

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.nextUrl = event.url;
    }

  }
}
